export default __webpack_public_path__ + "static/media/close.ec75d473.svg";